module.exports = __webpack_public_path__ + "img/prl.7ee71458.svg";